import React from "react";
import LandingPage from "./components/AuthPages/Landing/LandingPage";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Route, Routes } from "react-router-dom";
import AllRoutes from "./routes/routes";
import "./css/utility.scss";

const theme = createTheme({
  // typography: {
  //   fontFamily: "var(--font-family)",
  // },
});

class App extends React.Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/*" element={<AllRoutes />} />
        </Routes>
      </ThemeProvider>
    );
  }
}

export default App;
